module.exports = __webpack_public_path__ + "static/img/ca.36a398cb.svg";